import React from 'react';

import { BiCalendar } from 'react-icons/bi';

import { Container } from './styles';

interface ExplainDateProps {
  initial: string;
  last: string;
}

const ExplainDate: React.FC<ExplainDateProps> = ({ initial, last }) => {
  const normalizeDateBR = (date: string) => {
    const today = new Date().toISOString().split('T')[0];

    if (date === today) return 'Hoje';
    const [y, m, d] = date.split('-');
    return `${d}/${m}/${y}`;
  };
  return (
    <Container>
      <span>
        <BiCalendar />
      </span>
      {normalizeDateBR(initial)} - {normalizeDateBR(last)}
    </Container>
  );
};

export default ExplainDate;
